export type ChartType = 'line' | 'bar' | 'pie' | 'gauge';

export type ChartComponentType =
  | 'DONUT'
  | 'GAUGE'
  | 'PIE'
  | 'GROUPED_BAR'
  | 'STACKED_BAR'
  | 'HORIZONTAL_GROUPED_BAR'
  | 'HORIZONTAL_STACKED_BAR'
  | 'LINE';

export const ChartTypes = {
  Line: 'line' as ChartType,
  Bar: 'bar' as ChartType,
  Pie: 'pie' as ChartType,
  Gauge: 'gauge' as ChartType
} as const;
